module.exports = __webpack_public_path__ + "img/whispers_of_wood-white-logo.78e9a36.png";